import { render, staticRenderFns } from "./AccountRoleForm.vue?vue&type=template&id=f2593254"
import script from "./AccountRoleForm.vue?vue&type=script&lang=js"
export * from "./AccountRoleForm.vue?vue&type=script&lang=js"
import style0 from "./AccountRoleForm.vue?vue&type=style&index=0&id=f2593254&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports